var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoreGeneric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ilust-anavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.037,
    height: 121.037,
    viewBox: "0 0 121.037 121.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ilust-anavailable-2",
    "data-name": "ilust-anavailable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illust-storeClose"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 60.519,
    cy: 60.519,
    r: 60.519,
    fill: "#ebecf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(9.556 17.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(8.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8.613,0H77.534l8.619,26.22H0Z",
    fill: "#ed1652"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 71.17,
    height: 56.187,
    transform: "translate(7.492 26.22)",
    fill: "#0823cf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.284 40.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M15.289,30.578A15.289,15.289,0,1,1,30.578,15.287,15.289,15.289,0,0,1,15.289,30.578",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M14.659,6.812H9.024V1.177a1.107,1.107,0,1,0-2.21,0V6.812H1.18a1.108,1.108,0,1,0,0,2.212H6.814v5.635a1.107,1.107,0,1,0,2.21,0V9.024h5.635a1.108,1.108,0,1,0,0-2.212",
    transform: "translate(7.644 7.644)",
    fill: "#0823cf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0.14 26.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M80.207,4.869A6.192,6.192,0,0,1,76.3,3.478,6.2,6.2,0,0,1,74.166,0H86.248a6.2,6.2,0,0,1-2.135,3.479A6.192,6.192,0,0,1,80.207,4.869Zm-12.361,0a6.192,6.192,0,0,1-3.906-1.391A6.2,6.2,0,0,1,61.8,0H73.887a6.2,6.2,0,0,1-2.135,3.479A6.193,6.193,0,0,1,67.846,4.869Zm-12.361,0a6.192,6.192,0,0,1-3.906-1.391A6.2,6.2,0,0,1,49.444,0H61.526a6.2,6.2,0,0,1-2.135,3.479A6.192,6.192,0,0,1,55.485,4.869Zm-12.361,0a6.192,6.192,0,0,1-3.906-1.391A6.2,6.2,0,0,1,37.082,0H49.165A6.2,6.2,0,0,1,47.03,3.478,6.193,6.193,0,0,1,43.124,4.869Zm-12.361,0a6.192,6.192,0,0,1-3.906-1.391A6.2,6.2,0,0,1,24.722,0H36.8a6.2,6.2,0,0,1-2.135,3.479A6.192,6.192,0,0,1,30.763,4.869Zm-12.361,0A6.192,6.192,0,0,1,14.5,3.478,6.2,6.2,0,0,1,12.36,0H24.443a6.2,6.2,0,0,1-2.135,3.479A6.193,6.193,0,0,1,18.4,4.869Zm-12.361,0A6.193,6.193,0,0,1,2.134,3.478,6.2,6.2,0,0,1,0,0H12.082A6.2,6.2,0,0,1,9.947,3.478,6.192,6.192,0,0,1,6.041,4.869Z",
    transform: "translate(0 0)",
    fill: "#ed1652"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 101.671,
    height: 8.027,
    rx: 4.013,
    transform: "translate(0 80.267)",
    fill: "#ed1652"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreGeneric);
export default __webpack_public_path__ + "static/media/store-generic.9213fe391acb6adb325568bc54db73fe.svg";
export { ForwardRef as ReactComponent };